/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import Div from "@jumbo/shared/Div";
import { useDispatch, useSelector } from "react-redux";
import Loader from "@jumbo/components/Loader";
import { getSupplierList } from "app/redux/slice/supplierSlice";
import moment from "moment";
import { getLogsList } from "app/redux/slice/logsSlice";
import { getUserList } from "app/redux/slice/userSlice";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";

const Logs = () => {
  const dispatch = useDispatch();

  const logsData = useSelector((state) => state?.logs);
  const supplierData = useSelector((state) => state?.supplier);
  const userData = useSelector((state) => state?.user);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [supplierId, setSupplierId] = useState();
  const [performBy, setPerformBy] = useState();
  const [orderBy, setOrderBy] = useState("createdAt");
  const [moduleName, setModuleName] = useState("All");

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "logs" });

  const columns = [
    {
      id: "date",
      label: "Date",
      sort: false,
      minWidth: 120,
      render: (row) => moment(row?.date).format("DD-MM-YYYY"),
    },
    {
      id: "moduleName",
      label: "Module",
      sort: false,
    },
    {
      id: "vendor",
      label: "Vendor",
      render: (row) => row?.supplier?.name ?? "-",
    },
    {
      id: "product",
      label: "Perform by",
      sort: false,
      render: (row) => row?.performBy?.name ?? "-",
    },
    { id: "action", label: "Action", sort: false, minWidth: 300 },
  ];

  const getData = () => {
    localStorage.setItem("logs-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      ...(supplierId && { supplierId: supplierId?._id }),
      ...(moduleName !== "All" && { moduleName }),
      ...(performBy && { performBy: performBy?._id }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getLogsList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    dispatch(getSupplierList({ sort: 1, field: "name" }));
    dispatch(getUserList({ sort: 1, field: "name" }));
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {logsData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2.5}>
                    <JumboAutoComplete
                      options={supplierData?.list || []}
                      label="Vendor"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`supplierId`}
                      value={supplierId}
                      onChange={(evt, value) => setSupplierId(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2.5}>
                    <JumboAutoComplete
                      options={userData?.list || []}
                      label="Perform By"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`performBy`}
                      value={performBy}
                      onChange={(evt, value) => {
                        setPerformBy(value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2.5}>
                    <FormControl fullWidth>
                      <InputLabel>Modules</InputLabel>
                      <Select
                        name="moduleName"
                        id="moduleName"
                        value={moduleName}
                        label="Modules"
                        size="small"
                        onChange={(e) => setModuleName(e.target.value)}
                      >
                        <MenuItem></MenuItem>
                        {[
                          "All",
                          "Supplier",
                          "Supplier Rate",
                          "Mill Purchase",
                          "Knitter Order",
                          "Pre Book",
                          "Product",
                          "Variant",
                          "Color",
                          "Product Inward",
                          "Product Process",
                          "Supplier Price",
                          "Mill Order",
                          "Invoice",
                          "Purchase Order (PO)",
                          "Return",
                          "Assign Permission",
                          "Permission",
                          "Role",
                          "User",
                          "Party Number"
                        ].map((val) => {
                          return <MenuItem value={val}>{val}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={1.5}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Logs List
                </Typography>
              </Stack>
              <Table
                columns={columns}
                rows={logsData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={logsData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default Logs;
